/**
 * Hooks visuais partilhados por superfícies de reservas e modais.
 */

export const CalendarAnimations = {
  mounted() {
    const hasAnimateClass = this.el.classList.contains('calendar-animate');

    if (hasAnimateClass) {
      void this.el.offsetHeight;

      setTimeout(() => {
        try {
          this.el.classList.remove('calendar-animate');
        } catch (_) { }
      }, 800);
    }
  },

  updated() {
    const hasAnimateClass = this.el.classList.contains('calendar-animate');

    if (hasAnimateClass) {
      void this.el.offsetHeight;

      setTimeout(() => {
        try {
          this.el.classList.remove('calendar-animate');
        } catch (_) { }
      }, 800);
    }
  }
};

export const ModalTabs = {
  mounted() {
    this.scrollActiveIntoView();
    this.handleEvent('scroll_active_modal_tab', () => this.scrollActiveIntoView());
    this.handleEvent('ensure_menu_tab_visible', () => this.scrollMenuTabIntoView());
  },

  updated() {
    this.scrollActiveIntoView();
  },

  scrollActiveIntoView() {
    try {
      const active = this.el.querySelector('[role="tab"][aria-selected="true"]');
      if (active && typeof active.scrollIntoView === 'function') {
        active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    } catch (e) {
      console.warn('ModalTabs scroll failed:', e);
    }
  },

  scrollMenuTabIntoView() {
    try {
      const menuBtn = this.el.querySelector('[role="tab"][phx-value-tab="menu"]');
      if (menuBtn && typeof menuBtn.scrollIntoView === 'function') {
        menuBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' });
      }
    } catch (e) {
      console.warn('ModalTabs menu scroll failed:', e);
    }
  }
};

export const ReservationUiHooks = {
  CalendarAnimations,
  ModalTabs
};
